import { useState } from 'react';
import { Descriptions, Typography, Button, message } from 'antd';
import {
  formatDate, convertCentsIntoDollar, formatToDollar
} from "../../../../helpers/genericHelper";
import API from "../../../../services/API";
import { PLAID_ACCOUNT_STATE } from '../../../../constants/AppConstants';

const { Text } = Typography;

export default function PlaidDetailsRow({ details, userId }) {
  const [ownerName, setOwnerName] = useState(null);
  const [loading, setLoading] = useState(false);

  const getOwnerName = async () => {
    if (!details?.id || !userId) {
      console.error("Cannot fetch names, missing plaid id, access token or user id")
      message.error("Cannot fetch names, missing info")
      return;
    }
    
    setLoading(true);
    try {
      const response = await API.plaidOwnerName(Number(details.id), userId);
      const names = response.ownerNames || [];
      if (names.length > 0) {
        setOwnerName(names.join(', '));
      } else {
        setOwnerName('No owner names found');
      }
    } catch (error) {
      console.error('Error fetching owner name:', error);
      message.error('Failed to fetch bank owner name');
      setOwnerName('-');
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Descriptions layout="vertical" column={6} bordered>
        <Descriptions.Item label="Plaid Account ID" span={2}>
          { details?.plaidAccountId }
        </Descriptions.Item>
        <Descriptions.Item label="Access Token" span={2}>
          { details?.accessToken }
        </Descriptions.Item>
        <Descriptions.Item label="Last Updated" span={1}>
          { formatDate(details?.updateTs) }
        </Descriptions.Item>
        
        <Descriptions.Item label="Plaid Risk Level" span={1}>
          { details?.riskProfileResponse?.riskCheck?.riskLevel }
        </Descriptions.Item>
        <Descriptions.Item label="Underwriting Model" span={1}>
          { details?.creditLimit?.model || '-' }
        </Descriptions.Item>
        <Descriptions.Item label="Underwriting Rule Triggered" span={2}>
          { details?.riskProfileResponse?.creditLimit?.triggeredRule }
        </Descriptions.Item>
        <Descriptions.Item label="Computed Credit Limit (Annual)" span={1}>
          { formatToDollar(details?.creditLimit?.annualBaseLimitDollars) }
        </Descriptions.Item>
        <Descriptions.Item label="Computed Credit Limit (Monthly)" span={1}>
          { formatToDollar(details?.creditLimit?.monthlyBaseLimitDollars) }
        </Descriptions.Item>
        <Descriptions.Item label="Direct Deposit" span={1}>
          { convertCentsIntoDollar(details?.riskProfileResponse?.creditLimit?.directDepositCents) }
        </Descriptions.Item>
        <Descriptions.Item label="Routing Number" span={2}>
          { details?.routingNumber || '-' }
        </Descriptions.Item>
        
        <Descriptions.Item label="Fail Reason" span={4}>
          <p style={{ whiteSpace: "pre-line" }}>{details?.silaFailReason || '-'}</p>
        </Descriptions.Item>
        
        {[PLAID_ACCOUNT_STATE.LINKED, PLAID_ACCOUNT_STATE.LINK_FAILED, PLAID_ACCOUNT_STATE.PENDING].includes(details.accountState) && 
          <Descriptions.Item label="Bank Owner Name" span={4}>
            {ownerName ? (
              <Text>{ownerName}</Text>
            ) : (
              <Button
                type="primary" 
                size="small"
                onClick={getOwnerName}
                loading={loading}
              >
                Get Owner Name
              </Button>
            )}
          </Descriptions.Item>
        }
      </Descriptions>
    </>
  )
}